import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { Button, Alert } from '@commutifi-fe/ui';
import { accountActions, accountSelectors } from 'store/modules/accounts';
import { useAppDispatch, useSelector } from './store';
export function SuperAdminAlert() {
  const $ = _c(8);
  const dispatch = useAppDispatch();
  const superAdminViewAccountId = useSelector(accountSelectors.getSuperAdminViewAccountId);
  const currentAccountId = useSelector(accountSelectors.getCurrentId);
  if (!superAdminViewAccountId) {
    return null;
  }
  if (superAdminViewAccountId === currentAccountId) {
    return null;
  }
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span>Super Admin View</span>;
    t1 = <span className="u-margin-left--medium u-margin-right--medium">|</span>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FontAwesomeIcon icon={faUser} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== dispatch) {
    t3 = <div className="u-flex-align-center u-padding-vertical--tiny">{t0}{t1}<Button fitToContent={true} type="link" icon={t2} onClick={() => dispatch(accountActions.setSuperAdminViewAccountId(null))}>My account view</Button></div>;
    $[3] = dispatch;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      zIndex: 1000
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <Alert type="info" showIcon={true} closable={true} title={t3} banner={true} style={t4} />;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}